import { BaseCommand } from './BaseCommand';
import type { CommandActionContext, CommandShortcut } from '~/lib/stores/command/types';

export class ActionCommand extends BaseCommand {
  action: (options: CommandActionContext) => void;

  constructor(details: { id: string; name: string; icon: string; action: (options: CommandActionContext) => void }) {
    super({ id: details.id, name: details.name, icon: details.icon });
    this.action = details.action;
  }

  shortcuts: CommandShortcut[] = [
    {
      label: 'Use Command',
      keys: ['Enter'],
      action: (context) => this.action(context),
    } satisfies CommandShortcut,
    {
      id: 'favorite',
      label: 'Toggle Favorite',
      keys: ['Meta', 'Shift', 'L'],
      action: ({ commandStore }) => {
        commandStore.toggleFavorite(this.id);
      },
    } satisfies CommandShortcut,
  ];
}
